exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".employee-listing-assignment{display:flex;flex-direction:column;gap:.45rem;min-width:12rem}.employee-listing-assignment__item{display:flex;flex-direction:column;gap:.1rem;padding:.55rem .7rem;border:1px solid rgba(15,23,42,.08);border-radius:.8rem;background:rgba(248,250,252,.95)}.employee-listing-assignment__label{font-size:.69rem;line-height:1.1;letter-spacing:.04em;text-transform:uppercase;font-weight:700;color:#94a3b8}.employee-listing-assignment__value{font-size:.9rem;line-height:1.35;font-weight:600;color:#334155;word-break:break-word}", ""]);

// exports
